import React from 'react';
import styled from 'styled-components';
import { LayoutContext } from 'contexts';

const Content: React.FC = ({ children }) => {
  const { offsetTop, navHeight, blurBackgroundVisibility, footerHeight } =
    React.useContext(LayoutContext);

  return (
    <StyledContent
      $marginTop={offsetTop + navHeight}
      $marginBottom={footerHeight}
    >
      {children}
      {blurBackgroundVisibility && <BlurOverlay />}
    </StyledContent>
  );
};

const StyledContent = styled.div<{
  $marginTop: number;
  $marginBottom: number;
}>`
  min-height: ${({ $marginTop, $marginBottom }) =>
    `calc(${window.innerHeight}px - ${$marginTop}px - ${$marginBottom}px)`};
  margin-top: ${({ $marginTop }) => $marginTop}px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
`;

const BlurOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
`;

export default Content;
